/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IEventAction } from '../../table-actions/components/ami-table-actions/ami-table-actions.interface';
import { ISettingsAmiDetail } from './ami-details.interface';

@Component({
  selector: 'ami-details',
  templateUrl: './ami-details.component.html',
  styleUrls: ['../../../../assets/demo/badges.scss']
})
export class AmiDetailsComponent {
  @Input() settings: ISettingsAmiDetail;
  @Output() action = new EventEmitter<IEventAction>();

  onSendAction(action) {
    this.action.emit(action);
  }
}
